import Vue from 'vue';
import EvaluationForm from './components/EvaluationForm.vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

let vue_recaptcha_options = {
  siteKey: window.evaluation_script_data.google_recaptcha_site_key,
  loaderOptions: {
    autoHideBadge: false,
    explicitRenderParameters: {
      badge: 'bottomleft',
      // size: 'invisible',
    }
  }
};

Vue.use(VueReCaptcha, vue_recaptcha_options);

new Vue({
  render: h => h(EvaluationForm)
}).$mount('#evaluation-form');
